/* ==========================================================================
  main.js
========================================================================== */
var desktop_min_width = 1120;
var mobile_max_width = 1119;

/**
 * Initialize all instances of a component found by selector.
 *
 * @param {string}   selector  - CSS selector for the elements
 * @param {Function} component - Component init function
 * @param {string}   argKey    - Property name passed to the component
 * @param {Object}   [extra]   - Additional properties merged into each call
 */
function initAll(selector, component, argKey, extra) {
  document.querySelectorAll(selector).forEach(function (el) {
    var args = {};
    args[argKey] = el;
    if (extra) {
      for (var key in extra) { args[key] = extra[key]; }
    }
    component(args);
  });
}

// Components
initAll(".js-navigation", component_dropdown_menu, "menu", { desktop_min_width: desktop_min_width });
initAll(".utu-sites-menu", component_utu_sites_menu, "menu");
initAll(".image-carousel", component_image_carousel, "carousel");
initAll(".product-list-tabs", component_product_list_tabs, "main_element");
initAll(".product-details", component_product_details, "main_element");
initAll(".timeline", component_timeline, "timeline");
initAll(".facetwp-filters", component_facetwp_filters, "filters");
initAll(".numeric-navigation__facet-wp-pagination", component_facetwp_pagination, "pagination");
initAll(".search-form", component_search_form, "search_form");
initAll(".site-header__mobile-search", component_mobile_search_bar, "search_bar");
initAll(".products-mega-menu", component_products_mega_menu, "mega_menu", {
  desktop_min_width: desktop_min_width,
  mobile_max_width: mobile_max_width,
});

// Mobile menu (single instance)
component_mobile_menu({
  menu: document.querySelector(".js-mobile-menu"),
  site: document.querySelector(".js-page"),
  toggles: document.querySelectorAll(".js-menu-toggle"),
});

// Responsive videos
fitvids({ ignore: ".wp-block-file__embed" });

// Polyfill object-fit
if (typeof objectFitPolyfill === "function") {
  objectFitPolyfill();
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 */
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    }, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
}

// GLightbox — shared config for both instances
var glightboxDefaults = { touchNavigation: true, loop: false, autoplayVideos: false };

var lightbox = GLightbox(  // jshint ignore:line
  Object.assign({}, glightboxDefaults, { selector: ".glightbox" })
);

// Content images lightbox (added by markup-enhancements.js)
if (document.querySelectorAll(".glightbox-content").length) {
  var contentLightbox = GLightbox(  // jshint ignore:line
    Object.assign({}, glightboxDefaults, { selector: ".glightbox-content" })
  );
}
